import { PulseLoader } from "react-spinners"

export const SpinnerOverlay = () => {
	return (
		<div className="absolute inset-x-0 top-0 z-50 flex h-full items-center justify-center bg-[#aaaaaa50]">
			<PulseLoader size={80} />
		</div>
	)
}
